/**
 * Centralized product slider helper - manages wrapper height and slide opacity
 * Used by homepage collection sliders and product page related products
 */
var productSliderHelper = {
    animationFrameId: null,
    desktopBreakpoint: 768,

    // Update product opacity based on geometric visibility (desktop only)
    updateProductOpacity: function(element) {
        const swiperContainer = element.querySelector('.swiper-container');
        if (!swiperContainer) return;

        const containerRect = swiperContainer.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const containerRight = containerRect.right;

        const productWraps = element.querySelectorAll('.product-wrap');
        productWraps.forEach(productWrap => {
            const productRect = productWrap.getBoundingClientRect();
            const productWidth = productRect.width;

            // Calculate visible width
            const visibleLeft = Math.max(productRect.left, containerLeft);
            const visibleRight = Math.min(productRect.right, containerRight);
            const visibleWidth = Math.max(0, visibleRight - visibleLeft);
            const visibilityRatio = visibleWidth / productWidth;

            // Apply opacity based on visibility
            productWrap.style.transition = 'opacity 0.1s ease';

            const slide = productWrap.closest('.swiper-slide');

            if (visibilityRatio >= 0.5) {

                productWrap.style.opacity = '1';
                slide?.classList.remove('swiper-slide-partially-visible');
            } else {
                // Slide visible less than 50%
                productWrap.style.opacity = '0.5';
                slide?.classList.add('swiper-slide-partially-visible');
            }
        });
    },
    // Continuous opacity update during animations
    startContinuousUpdate: function(element) {
        const self = this;

        const update = function() {
            self.updateProductOpacity(element);
            self.animationFrameId = requestAnimationFrame(update);
        };

        // Cancel any existing animation frame
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }

        update();
    },

    stopContinuousUpdate: function() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    },

    // Common swiper configuration for product sliders
    getCommonConfig: function(element) {
        const self = this;
        return {
            keyboard: true,
            slidesPerView: 2.5,
            spaceBetween: 8,
            allowTouchMove: true,
            freeMode: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragClass: 'swiper-scrollbar-drag',
                dragSize: 200
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 3.5,
                }
            }
        };
    },

    // Initialize a product slider with common setup
    initSlider: function(element, swiperSelector) {
        const config = this.getCommonConfig(element);
        const swiper = new Swiper(element.querySelector(swiperSelector), config);
        const self = this;

        // Update handler function
        const updateHandler = function() {
            self.updateProductOpacity(element);
        };

        // Initial update when swiper is ready
        swiper.on('init', updateHandler);

        // 'setTranslate' fires during any position change (drag, arrows, animations)
        swiper.on('setTranslate', updateHandler);

        // 'transitionEnd' ensures update at the end of arrow/programmatic animations
        swiper.on('transitionEnd', updateHandler);

        // Update on window resize
        swiper.on('resize', updateHandler);

        return swiper;
    }
};
